import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Label,
  Form,
  CustomInput,
  FormText,
  InputGroup,
  Input,
} from 'reactstrap';
import {
  BtnOutlineRed,
  BtnOutlineGreen,
  BtnModalTable,
  BtnDisabled,
} from '../../styled-components';
import DateInput from '../../commons/DateInput';

const ModalAddPaymentPolis = (props) => {
  const [t] = useTranslation('CONTACTS');
  const { data: contract, className = '', onAddPayment = () => { } } = props;

  const [errors, setErrors] = useState({});
  const [modal, setModal] = useState(false);

  const [date, setDate] = useState('');
  const [type, setType] = useState('');
  const [anniversaryConsumption, setAnniversaryConsumption] = useState(0);
  const [extraSharePolis, setExtraSharePolis] = useState(0);

  const toggle = () => {
    setModal(!modal);
  };

  const onAddPaymentSubmit = () => {
    if (!date || !type || !anniversaryConsumption || !extraSharePolis) {
      const errors = {};
      errors.date = !date;
      errors.type = !type;
      errors.anniversaryConsumption = !anniversaryConsumption;
      errors.extraSharePolis = !extraSharePolis;
      return setErrors(errors);
    }
    onAddPayment({
      contractId: contract._id,
      data: {
        date,
        type,
        anniversary_consumption: anniversaryConsumption,
        polis_share: extraSharePolis,
      },
    });

    setDate('');
    setType('');
    setAnniversaryConsumption(0);
    setExtraSharePolis(0);
    setErrors({});
    toggle();
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ marginLeft: '10px' }}>
          {(contract.paid === true && (
            <BtnDisabled type="button" disabled={true}>
              {t('ROYALTY:ADD_PAYMENT')}
            </BtnDisabled>
          )) || (
              <BtnModalTable
                type="button"
                onClick={(event) => {
                  event.stopPropagation();
                  toggle();
                }}
              >
                {t('ROYALTY:ADD_PAYMENT')}
              </BtnModalTable>
            )}
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>
          {t('ROYALTY:MODAL_RECEIPT_INVOICE_TITLE')}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onAddPaymentSubmit();
          }}
        >
          <ModalBody>
            <div className="max-width-form">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label>{t('RECEIPT_DATE')} *</Label>
                    <DateInput value={date} onChange={setDate} />
                    {errors.date && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup>
                    <Label>{t('IMPORT_TYPE')} *</Label>
                    <CustomInput
                      type="select"
                      id="type"
                      name="customSelect"
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="">{t('IMPORT_TYPE_PLACEHOLDER')}</option>
                      <option value="TRANSFER">{t('TRANSFER')}</option>
                      <option value="CARD">{t('CARD')}</option>
                      <option value="RIBA">{t('RIBA')}</option>
                      <option value="CASH">{t('CASH')}</option>
                      <option value="OTHER">{t('OTHER')}</option>
                    </CustomInput>
                    {errors.type && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup>
                    <Label>{t('ROYALTY:ANNIVERSARY_CONSUMPTION')} *</Label>
                    <InputGroup>
                      <Input
                        type="number"
                        step="0.01"
                        placeholder="0.00"
                        name="anniversaryConsumption"
                        onChange={(e) =>
                          setAnniversaryConsumption(Number(e.target.value))
                        }
                      />
                    </InputGroup>
                    {errors.anniversaryConsumption && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup>
                    <Label>{t('ROYALTY:EXTRA_SHARE_POLIS')} *</Label>
                    <InputGroup>
                      <Input
                        type="number"
                        step="0.01"
                        placeholder="0.00"
                        name="extraSharePolis"
                        onChange={(e) =>
                          setExtraSharePolis(Number(e.target.value))
                        }
                      />
                    </InputGroup>
                    {errors.extraSharePolis && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default ModalAddPaymentPolis;
